import { MutationTree } from 'vuex'
import { ActionsState, Action as ActionInterface } from '@/store/modules/actions/actionsTypes'
import { ChronometerNewActionInfo } from '@/store/modules/actions/actionsTypes'

export const mutations: MutationTree<ActionsState> = {
  FETCH_ACTIONS(state, actions) {
    state.actions = actions
  },
  FETCH_ACTION(state, action) {
    state.action = action
  },
  FETCH_PARENT_ACTION(state, parentAction: ActionInterface): void {
    state.parentAction = parentAction
  },
  RESET_ACTIONS(state) {
    state.actions = null
  },
  RESET_PARENT_ACTION(state): void {
    state.parentAction = null
  },
  SAVE_SELECTED_ACTION_TYPE(state, actionType = '') {
    state.selectedActionType = actionType
  },
  SET_CHRONOMETER_NEW_ACTION_INFO(state, data) {
    state.chronometerNewActionInfo = data
  },
  RESET_CHRONOMETER_NEW_ACTION_INFO(state) {
    const chronometerInfo: ChronometerNewActionInfo = {
      start: '',
      end: '',
      duration: 0
    }
    state.chronometerNewActionInfo = chronometerInfo
  },
  SET_DUPLICATE_ACTION_ID(state, data){
    state.duplicateActionId = data
  },
}
